import React from 'react';
function PaperPlane({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M20 4L11 13" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 4L14.4 20L11.2 12.8L4 9.6L20 4Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default PaperPlane;
